var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      staticStyle: { fill: "currentColor" },
      attrs: { viewBox: "0 0 203 234", xmlns: "http://www.w3.org/2000/svg" },
    },
    [
      _c("path", {
        attrs: {
          d: "M0 116.709L67.3848 77.8058V155.612V233.417L0 194.515V116.709ZM168.452 58.3595L67.3848 0L0 38.9029L67.3848 77.8058L134.77 116.709L67.3848 155.612L134.77 194.515L168.462 175.068C189.314 163.034 202.154 140.787 202.154 116.719C202.144 92.6412 189.304 70.3933 168.452 58.3595Z",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }